import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  Table,
  TableBody,
  TableRow,
  TableContainer,
  TableHead,
  TableCell,
} from '@material-ui/core';

import { SORT_DIRECTION } from 'src/data/common';
import { ACCOUNT_FIELD } from 'src/data/performance';
import { CustomTableSortLabel } from 'src/components/CustomTableSortLabel';
import { AccountRow } from '../AccountRow';
import { useStyles } from './useStyles';
import { CHANNEL } from 'src/data/channel';

export const ACCOUNT_TABLE_COLUMNS = [
  { field: ACCOUNT_FIELD.toggle, title: '', style: { width: 104 } },
  { field: ACCOUNT_FIELD.name, title: 'Account Name', style: { width: 442 } },
  { field: ACCOUNT_FIELD.id, title: 'Account ID', style: { width: 139 } },
  { field: ACCOUNT_FIELD.connectedState, title: 'Status', style: { width: 150 } },
];

const getColumnTitle = (column, channel) => {
  if (column.field === ACCOUNT_FIELD.name) {
    return channel === CHANNEL.facebook ? 'Ads Manager Accounts' : 'Google Ad Accounts';
  }
  return column.title;
};

export const AccountsTable = ({
  accounts,
  connectedAccountIds,
  selectedAccountIds,
  onAccountClick,
  onSortChange,
  sortField,
  sortDirection,
  channel,
}) => {
  const styles = useStyles();

  const createSortHandler = (field) => () => {
    onSortChange(field);
  };

  return (
    <TableContainer className={styles.root}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {ACCOUNT_TABLE_COLUMNS.map((column) => (
              <TableCell
                key={column.field}
                className={cx(styles.title)}
                style={column.style}
              >
                <CustomTableSortLabel
                  active={sortField === column.field}
                  direction={sortField === column.field ? sortDirection : SORT_DIRECTION.asc}
                  onClick={createSortHandler(column.field)}
                >
                  {getColumnTitle(column, channel)}
                </CustomTableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {accounts?.map((account) => (
            <AccountRow
              key={account.id}
              account={account}
              onAccountClick={onAccountClick}
              isConnected={connectedAccountIds.includes(account.id)}
              isChecked={selectedAccountIds.includes(account.id)}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

AccountsTable.propTypes = {
  className: PropTypes.string,
  accounts: PropTypes.arrayOf(PropTypes.shape({})),
  selectedAccountIds: PropTypes.arrayOf(PropTypes.string),
  onAccountClick: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  sortField: PropTypes.string,
  sortDirection: PropTypes.string,
  channel: PropTypes.string,
};

AccountsTable.defaultProps = {
  className: null,
  accounts: null,
  selectedAccountIds: null,
  sortField: null,
  sortDirection: null,
  channel: null,
};
